import React from 'react';
import { useAuth } from '../../providers/auth-provider';
import AssessmentHeader from './assessment-header';
import ClientHeader from './client-header';
import { ROLES } from '../../config/constants';

function Header() {
  const auth = useAuth();

  if (auth.userRole === ROLES.ASSESSMENT_USER) {
    return <AssessmentHeader />;
  }

  return <ClientHeader />;
}

export default Header;
